import axios from 'axios';

export default function({ customMutations }) {
  return {
    SET_ITEMS: (state, items) => {
      state.items.isLoading = false;
      state.items.data = items;
      state.items.request = null;
    },
    SET_ITEMS_ERROR: (state, error) => {
      if (!axios.isCancel(error)) state.items.isLoading = false;
      state.items.error = error;
    },
    SET_SEARCH: (state, search) => {
      state.filters = { ...state.filters, search };
    },
    SET_IDX: (state, idx) => {
      state.idx = idx;
    },
    SET_ITEMS_REQUEST: (state) => {
      state.items.isLoading = true;
      state.items.data = [];
      state.items.error = null;
      const axiosSource = axios.CancelToken.source();
      state.items.request = {
        cancel: axiosSource.cancel,
        token: axiosSource.token,
      };
    },
    ...customMutations,
  };
}
